<template lang="pug">
.range-select-form
  .range-select-form__button(
    v-bind:title="_defaultValue"
    tabindex="0"
    @click="onClickSelect($event)"
  ) {{ _defaultValue }}
  range-select-content(
    v-if="showContent"
    @close="closeSelectList"
    @onChangeAge="changeAge"
    :default-value="_defaultValue"
  )
</template>

<script>
import RangeSelectContent from "./components/RangeSelectContent.vue";

export default {
  name: "RangeSelectForm",
  components: {
    RangeSelectContent
  },
  props: {
    defaultValue: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showContent: false
    };
  },
  methods: {
    changeAge(value) {
      this._defaultValue = value;
    },
    closeSelectList() {
      this.showContent = false;
    },
    toggleSelectList() {
      this.showContent = !this.showContent;
    },
    onClickSelect(e, type) {
      if (this.showContent) {
        this.toggleSelectList();
        return;
      }
      const _e = e;
      if (!type) {
        setTimeout(() => {
          this.onClickSelect(_e, "second");
        }, 0);
      } else {
        e.preventDefault();
        e.stopPropagation();
        this.toggleSelectList();
      }
    }
  },
  computed: {
    _defaultValue: {
      cache: false,
      get() {
        return this.defaultValue;
      },
      set(value) {
        this.$emit("onChangeDefaultValue", value, this.type);
      }
    }
  }
};
</script>
